<!--
    Summary:
        首页
    ChangeLog:
        zty on 2021/12/17 added
-->
<template>
  <div class="v-home">
     <div class="v-swipe">
       <!-- <div class="banner">
         <img class="banner-img-s" src="../assets/images/home/home_banner.jpg"/>
       </div> -->
       <el-carousel 
        :interval="4000" 
        height="600px" 
        arrow="always" 
        indicator-position="inside"
      >
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <el-image :src="item.src" class="banner-img-s" fit="contain" />
        </el-carousel-item>
      </el-carousel>
       <!-- <div class="brand_introduction">
         <div class="introduction_content">
           <div class="title">品牌介绍</div>
           <div class="introduction_content_info">
             11月10日，在2017年中山全国结直肠癌多学科（MDT）诊疗学习班上，“上海结直肠肿瘤微创工程技术研究中心”正式宣告成立。上海结直肠肿瘤微创工程技术研究中心
             是由上海市科学技术主管部门于2017年批准成立的省级工程技术研究中心，由复旦大学附属中山医院牵头，联合上海，成为...
           </div>
         </div> 
       </div> -->
      
      <!--产品介绍-->
      <!-- <div class="product_introduction">
        <div class="product_content">
          <div class="product_title">{{$t('NavabarText.product_introduct')}}</div>
          <div class="product_destription">
            {{$t('productIntroduct.product_desc')}}
          </div>

          <div class="product_info">

            <div class="product_info_item four_transfer" @click="productMore()">
              <div class="item_img">
                <img src="../assets/images/home/product_one.png" />
              </div>
              <div class="item_title">{{$t('productIntroduct.product_one')}}</div>
           
            </div>
            
            <div class="product_info_item rightturnleft" @click="productMore()">
              <div class="item_img">
                <img src="../assets/images/home/product_two.png" />
              </div>
              <div class="item_title">{{$t('productIntroduct.product_two')}}</div>
             
            </div>

            <div class="product_info_item rightturnleft" @click="productMore()">
              <div class="item_img">
                <img src="../assets/images/home/product_three.jpg" />
              </div>
              <div class="item_title">{{$t('productIntroduct.product_three')}}</div>
            
            </div>

          </div>

          <div class="more_s">
             <div class="more_c">
                <div class="more_btn" @click="productMore()">{{$t('indexText.more')}}</div>
             </div>
           </div>
        </div>
      </div> -->
      <!--产品介绍-->

      
      <div class="company_introduction">
        <div class="company_introd_info">
          <div class="company_introd_detail">
            <div class="title">{{$t('NavabarText.navbr_child_about_1')}}</div>
            <div class="detail_content">
              <div class="item_c">
                <div class="item_c_img">
                  <img src="../assets/images/aboutUs/about_two.png"/>
                </div>
              </div>
              <div class="item_c">
                <div class="item_c_text">
                  <div class="t_title">{{$t('NavabarText.company_introduct')}}</div>
                  <div class="t_content">{{$t('About_Navbar.introduct')}}
                  </div>
                </div>
              </div>
            </div>
             <div class="detail_content">
              <div class="item_c">
                <div class="item_c_text">
                  <div class="t_title">{{$t('NavabarText.company_team')}}</div>
                  <div class="t_content">{{$t('About_Navbar.team_desc')}}
                  </div>
                </div>
              </div>
              <div class="item_c">
                <div class="item_c_img">
                  <img src="../assets/images/aboutUs/about_us_old.png"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--新闻资讯-->
      <div class="news_real_time">
        <div class="news_info">
           <div class="news_real_time_title">{{$t('NavabarText.navbr_new_one')}}</div>
          <div class="news_content downGoTotop_one">
            <div class="news_img ">
              <img src="../assets/images/home/news_real_time_one.png" />
            </div>
            <div class="news_content_info">

              <div class="news_item rightturnleft_one" v-for="item in $store.state.CompanyData" :key="item.id" @click="watchDetail(item)">
                <div class="date_info">
                  <div class="date_date">{{item.month}}/{{item.date}}</div>
                  <div class="date_year">{{item.year}}</div>
                </div>
                <div class="news_abstract">
                  <div class="abstract_title">{{item.title}}</div>
                  <div class="abstract_info">
                   {{item.articleAbstract}}
                  </div>
                </div>
              </div>

              
            </div>
          </div>
        </div>
      </div>
      <!--新闻资讯-->
     </div>
  </div>
</template>

<script>

import {getArticleByTypeList,getProductList} from '../service/service'
export default {
  name: 'home',
  computed: {
    isEn: function () {
      return this.$store.state.lang == 'en-US'
    }
  },
  metaInfo () {
    return {
      title: this.pageTitle
    }
  },
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval]
    },
    'companyId':function(nval,oval){
      if(nval!=0){
        this.getArticleByCompanyeList(1,2);
      }
    },
    'industryId':function(nval,oval){
      if(nval!=0){
        this.getArticleByIndustryList(1,2);
      }
    },
    '$store.state.CompanyData': function (nval, oval) {
       this.companyData=nval;
    },
  },
  components: {

  },
  data () {
    return {
      pageTitle: '广州市熵达贸易有限公司',
      videoActive:'operation',
      companyCode:'company_news',//公司资讯
      companyId:0,//公司资讯Id
      industryNewsCode:'industry_news',
      industryId:0,
      companyData:[],
      showCompanyData:true,
      bannerList:[
        {src:require('@/assets/images/home/home_banner_1.jpg')},
        {src:require('@/assets/images/home/home_banner_2.jpg')},
        {src:require('@/assets/images/home/home_banner_3.jpg')},
      ]
    }
  },
  mounted () {
    // if(this.$store.state.ArticleTypeData){
    //   let ArticleTypeData=this.$store.state.ArticleTypeData;
    //   console.log('jin:',ArticleTypeData)
    //   ArticleTypeData.map((v)=>{
    //     if(v.code==this.companyCode){
    //       this.companyId=v.id
    //     }else if(v.code==this.industryNewsCode){
    //       this.industryId=v.id
    //     }
    //   });

    // }
    // this.getProductList(1,3);
  },
  beforeDestroy () {
    window.onscroll = null;
  },
  methods: {
    watchDetail(item){
        this.$router.push({
            path: '/article?id='+item.id
        });
    },
    watchVideoMore(){
      this.$router.push({
        path:'/video'
      })
    },
    productMore(){
      this.$router.push({
        path:'/product'
      })
    },
    videoClick(val){
      this.videoActive=val;
      this.$router.push({
        path: val
      })
    },
    
    async getArticleByCompanyeList(pageNum,pageSize){
       let resp=await getArticleByTypeList(this.companyId,pageNum,pageSize);
       if(resp){
         this.companyData=[];
         resp.data.map((v)=>{
           let dateN=new Date(v.effectiveTime)
           v.year=dateN.getFullYear();
           v.month=dateN.getMonth()+1;
           v.month=v.month*1>9?v.month:'0'+v.month
           v.date=dateN.getDate();
           v.date=v.date*1>9?v.date:'0'+v.date
         })
         this.companyData=resp.data;
       }
    },
    async getArticleByIndustryList(pageNum,pageSize){
       let resp=await getArticleByTypeList(this.industryId,pageNum,pageSize);
       if(resp){
         resp.data.map((v)=>{
           let dateN=new Date(v.effectiveTime)
           v.year=dateN.getFullYear();
           v.month=dateN.getMonth()+1;
           v.date=dateN.getDate();
           v.month=v.month*1>9?v.month:'0'+v.month
           v.date=dateN.getDate();
           v.date=v.date*1>9?v.date:'0'+v.date
           this.companyData.push(v)
         })
         
       }
    },
    
     async getProductList(typeId,pageNum,pageSize){
         let resp=await getProductList(typeId,pageNum,pageSize)
         if(resp){
             resp.data.map((v)=>{
                 v.mainImgUrl=process.env.BASE_IMG_URL+v.mainImgUrl;
             })
             this.productData=resp.data;
             let count=this.productData.length;
             if(count%3>0&&count>3){
               this.standing_positon=3-count%3;
             }else{
                 this.standing_positon=0;
             }
         }
     },
  },
}
</script>


<style scoped lang="scss">
 @import '../assets/css/animation.css';
.v-home {
  .v-swipe{
    width:100%;
    height: 100%;
    overflow: hidden;
    .banner{
     height: 600px;
    .banner-img-s{
      width:100%;
      height: 100%;
    //  object-fit: fill;
    }
    }
    .brand_introduction{
      width:100%;
      background-color: #4f7cbd;
      .introduction_content{
        width:70%;
        margin:auto;
        padding:30px 10px;
        text-align: left;
        .title{
          color:#ffffff;
          font-size:40px;
          font-weight: bold;
        }
        .introduction_content_info{
          margin-top:10px;
          font-size:16px;
          line-height: 30px;
          color:#ffffff;
        }
      }
    }


    .video-class{
      width:100%;
      background-color: #ffffff;
      .video_content{
        width:70%;
        text-align: center;
        margin:auto;
        padding-top:111px;
        padding-bottom:111px;
        .video_choice{
          display: flex;
          justify-content: center;
          align-items: center;
          .video_choice_title{
            
                color:#4f7cbd;
                font-size:40px;
                font-weight: bold;
          }
          .choice_item{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 60px;
            padding:15px 28px;
            background-color: #ffffff;
            font-size:18px;
            cursor: pointer;
            &:last-child{
              margin-right: 0px !important;
            }
          }
          .choice_item:hover{
            background-color: #4f7cbd !important;
            border-radius: 26px !important;
            color:#ffffff !important;
            padding:15px 28px !important;
          }
          .choice_item_active{
            padding:15px 28px;
            background-color: #4f7cbd;
            border-radius: 26px;
            color:#ffffff !important;
          }
        }
        .video_example{
          margin-top:84px;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex-direction: row;
          margin-bottom:84px;
          cursor: pointer;
          &:last-child{
            margin-bottom:0px !important;
          }
          .video_image_s{
          }
          .video_con_info{
            display:flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            margin-left:48px;
            .video_title{
              font-size:18px;
              color:#333333;

            }
            .video_publish_date{
              font-size:15px;
              color:#333333;
              margin-top:5px;
            }
            .video_abstract{
              text-align: left;
              font-size:16px;
              color:#999999;
              margin-top:21px;
            }
          }
        }
      }
    }


    .more_s{
          width: 100%;
          text-align: center;
          .more_c{
            display: flex;
            justify-content: center;
            cursor: pointer;
            .more_btn{
              width: 147px;
              height: 49px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 25px;
              border: solid 2px #4f7cbd;
              color:#2750a2;
              font-size:20px;
              letter-spacing: 2px;
            }
            .more_btn:hover{
              background-color: #4f7cbd !important;
              color:#ffffff !important;
            }
          }
    }

    .product_introduction{
      width:100%;
      background: url('~@/assets/images/home/background_one.png') no-repeat;
      background-size: 100% 100%;
      text-align: left;
      .product_content{
        width:70%;
        margin: auto;
        padding-top:87px;
        padding-bottom:52px;
        text-align: center;
        .product_title{
          color:#4f7cbd;
          font-weight: bold;
          font-size: 40px;
        }
        .product_destription{
          text-align: left;
          margin-top:37px;
          font-size:18px;
          line-height: 30px;
        }
        .product_info{
          padding-top:60px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          padding-bottom:40px;
          .product_info_item{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            padding:30px 35px;
            background-color: #ffffff;
            width:388px;
            margin-right:18px;
            margin-bottom:18px;
            &:last-child{
              
            margin-right:0px !important;
            }
            .item_img{
              // width:319px;
              // height: 295px;height: 295px;
              height: 295px;
              background-color: #ffffff;
              img{
                width:100%;
                height: 100%;
              }
            }
            .item_title{ 
              height: 40px;
              font-size: 20px;
              font-weight: bold;
              // letter-spacing: 2px;
              color: #333333;
              font-family: MicrosoftYaHei;
            }
            .item_description{
              position: relative;
              padding-top:20px;
              text-align: left;
              font-size:16px;
            }
            .item_description:before{
              content:" ";
              position:absolute;
              left:0;
              top:8px;
              width:100%;
              height:2px;
              transform:scaleY(.5);
              background-color:#eeeeee;
            }
          }
        }
      }
    }


    .news_real_time{
      width:100%;
      background-color: #ffffff;
      .news_info{
        width:70%;
        margin:auto;
         padding-top:100px;
          padding-bottom:121px;
        .news_real_time_title{
            font-size: 40px;
            font-weight: bold;
            color: #4f7cbd;
            padding-bottom:30px;
        }
        .news_content{
          display: flex;
          // justify-content: flex-start;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          flex-direction: row;
         
          .news_img{
            width:488px;
            margin-bottom:20px;
            img{
              width:100%;
              height: 100%;
            }
          }
          .news_content_info{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            margin-left:50px;
            .news_item{            
              margin-bottom:40px;  
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              flex-direction: row;
              position: relative;
              .date_info{
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-direction: column;
                .date_date{
                  font-size:30px;
                  font-weight: bold;

                }
                .date_year{
                  font-size:16px;
                  color:#333333;
                }
              }
              .news_abstract{
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-direction: column;
                margin-left:20px;
                width:493px;
                .abstract_title{
                  font-size:23px;
                  // font-weight: bold;
                  color:#333333;
                  text-align: left;
                }
                .abstract_info{
                  font-size:20px;
                  color:#999999;
                  line-height: 30px;
                  padding-top:11px;
                  text-align: left;
                 
                  // width:493px;
                }
              }
              
            }
            
            .news_item :after{
              content:" ";
              position:absolute;
              left:0;
              bottom:-10px;
              width:100%;
              height:1px;
              transform:scaleY(.5);
              background-color:#eeeeee;
              
            }
            .news_item {
              &:last-child :after{
                  height: 0px !important;
              }
            }
                      
          }
        }
      }
    }
    
  }

  
  .company_introduction{
    width:100%;
    background: url('~@/assets/images/aboutUs/background_one.png') no-repeat;
    background-size: 100% 100%;
    // height: 1034px;
    .company_introd_info{
      width:70%;
      margin:auto;
      
      .company_introd_detail{
        padding:102px 0px;
        .title{
          color:#4f7cbd;
          font-size: 40px;
          font-weight: bold;
          margin-bottom: 71px;
        }
        .detail_content{
          display: flex;
          align-items: center;
          justify-content: center;
          .item_c{
            padding-bottom:73px;
            padding-left:130px;
            .item_c_img{
              width:980px;
              // height: 320px;
              img{
                width:100%;
                height: 100%;
              }
            }
            .item_c_text{
              text-align: left;
              width: 580px;
              .t_title{
                font-size: 21px;
                font-weight: bold;
                color:#333333;
                margin-bottom: 27px;
              }
              .t_content{
                
                font-size: 21px;

                line-height: 40px;
                color:#333333;

              }
            }
            
          }
        }
      }
    }
}
}
</style>




<style>

/* 超小屏幕（手机，小于 768px） */
/* 没有任何媒体查询相关的代码，因为这在 Bootstrap 中是默认的（还记得 Bootstrap 是移动设备优先的吗？） */

/* 小屏幕（平板，大于等于 768px） */
@media (min-width: @screen-sm-min) { 
   
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media (min-width: @screen-md-min) { 

 }

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: @screen-lg-min) { 

}
@media (max-width: 750px){
  .video_example{
    flex-wrap: wrap !important;
  }
  .video_image_s{
    margin-bottom:25px !important;
  }
  .video_abstract{
    text-indent:28px !important ;
  }
 
}
@media (min-width: 750px) and (max-width: 860px){

}
@media (min-width: 860px) and (max-width: 1200px){
  
 
}
@media (min-width: 1480px){                  
  .introduction_content{
    width:60% !important;
  }
  .video_content{
    width:60% !important;
  }
  .product_introduction .product_content{
    width:60% !important;
  }
  
  .news_info{
     width:60% !important;
  }
  .news_info .news_content_info{
    margin-left:120px !important;
  }
  .news_info .news_img{
    width: 500px !important;
  }

}


@media (min-width: 1148px) and (max-width: 1250px){                  
  .product_info .product_info_item{
     padding:20px 25px !important;
     width:350px  !important;
     margin-right:18px;
     margin-bottom:18px;
   }

}


@media (min-width: 994px) and (max-width: 1150px){                  
  .product_info .product_info_item{
     padding:10px 15px !important;
     width:310px  !important;
   }

}
@media (min-width: 900px) and (max-width: 1010px){                  
  .product_info .product_info_item{
     padding:5px 10px !important;
     width:280px  !important;
   }

}
@media (min-width: 800px) and (max-width: 920px){                  
  .product_info .product_info_item{
     padding:30px 35px !important;
     width:388px  !important;
   }

}

@media (max-width: 800px){   
  .product_info {
    justify-content: center !important;
  }               
  .product_info .product_info_item{
     padding:30px 35px !important;
     width:488px  !important;
     margin-right: 0px !important;
   }

}

@media (min-width: 1055px) and (max-width: 1182px){                  
  .news_img{
    width:388px !important;
            
  }

}
@media (min-width: 951px) and (max-width: 1085px){                  
  .news_img{
    width:358px !important;
            
  }
  .news_abstract{
    margin-left:20px !important;
    width:403px !important;
  }
}

@media (min-width: 836px) and (max-width: 951px){                  
  .news_img{
    width:328px !important;
            
  }
  .news_abstract{
    margin-left:20px !important;
    width:340px !important;
  }
}
@media (min-width: 800px) and (max-width: 855px){                  
  .news_img{
    width:320px !important;
            
  }
  .news_abstract{
    margin-left:10px !important;
    width:290px !important;
  }
}
@media (max-width: 800px){                  
  .news_img{
    width:488x !important;
    margin-bottom: 60px !important;
  }
  .news_abstract{
    margin-left:35px !important;
    width:340px !important;
  }
  .news_content_info{
    margin-left: 0px !important;
  }
  .news_content{
    justify-content: center !important;
    
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue